import { CategoryConfigurationStatus } from 'src/graphql';
import type { DefaultTheme } from 'styled-components';

export type CategoryStatusBadgeAppearance = {
  text: string;
  color: string;
  backgroundColor: string;
  width?: string;
  borderColor?: string;
};

export const getCategoryStatusBadgeAppearance = (
  status: CategoryConfigurationStatus,
  theme: DefaultTheme,
): CategoryStatusBadgeAppearance => {
  switch (status) {
    case CategoryConfigurationStatus.Active:
      return {
        text: 'Active',
        color: theme.isVaultVariant
          ? theme.newPalette.neutral.N0
          : theme.atlas.semantic.color.status.success.textDefault,
        backgroundColor: theme.isVaultVariant
          ? theme.newPalette.neutral.N800
          : theme.atlas.semantic.color.status.success.default,
      };
    case CategoryConfigurationStatus.Inactive:
      return {
        text: 'Inactive',
        color: theme.isVaultVariant
          ? theme.newPalette.neutral.N800
          : theme.atlas.semantic.color.type.default,
        backgroundColor: theme.isVaultVariant
          ? theme.newPalette.neutral.N0
          : theme.atlas.core.color.concrete[90],
        borderColor: theme.isVaultVariant
          ? theme.newPalette.neutral.N400
          : undefined,
      };
    case CategoryConfigurationStatus.FormRequired:
      return {
        text: 'Form required',
        color: theme.isVaultVariant
          ? theme.newPalette.neutral.N800
          : theme.atlas.semantic.color.type.default,
        backgroundColor: theme.isVaultVariant
          ? theme.newPalette.turquoise.T100
          : theme.atlas.semantic.color.status.warning.default,
        width: '100%',
      };
    default:
      return {
        text: 'Live',
        color: theme.isVaultVariant
          ? theme.newPalette.neutral.N0
          : theme.atlas.semantic.color.type.inverse,
        backgroundColor: theme.isVaultVariant
          ? theme.newPalette.neutral.N800
          : theme.atlas.semantic.color.type.default,
      };
  }
};
